import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useBrand } from '../context/BrandContext'
import { colors, radius, s, ui } from '../styles/theme'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000'

const LISTE_BOLUMLERI = [
  { key: 'editor', varsayilan: 'Editörün Seçtikleri', ipucu: 'Slayt olarak gösterilir. Ek Bilgi 7 dolu olan kitabın motto cümlesi kartın sağında tırnak içinde görünür.' },
  { key: 'setler', varsayilan: 'Tematik Setler', ipucu: 'Set/takım ürünleri. Boş bırakılırsa bölüm basılmaz.' },
  { key: 'yayinlar', varsayilan: 'Öne Çıkan Yayınlar', ipucu: 'Kapak üzerindeki işarete dokununca Ek Bilgi 7 motto metni açılır.' }
]

const MODEL_KURALLARI = [
  { ad: 'Yazar portresi', aciklama: 'T-Soft panelindeki yazar görseli; yoksa baş harf rozeti' },
  { ad: 'Yazar adı ve künye', aciklama: 'Ad başlığı ile birlikte Kitap sayısı, Yayınevi, Yayın Dönemi' },
  { ad: 'Biyografi', aciklama: 'T-Soft panelinden girilen yazar biyografisi' },
  { ad: 'Etiketler', aciklama: 'Kitap konularından üretilir, aramaya bağlanır' },
  { ad: 'Yeni & Öne Çıkanlar', aciklama: 'Yazarın öne çıkan kitapları; 5’ten fazlaysa kaydırmalı' },
  { ad: 'Öne Çıkan Kitap', aciklama: 'En çok satan kitap; motto cümlesi (Ek Bilgi 7) kartın sağında tırnak içinde' },
  { ad: '{Yazar} Kitapları', aciklama: '8’den fazla kitabı olan yazarlarda tüm kitaplar şeridi' }
]

function Kutu({ baslik, ipucu, sag, children }) {
  return (
    <div style={s.card}>
      <div className="sx-wrap" style={{ ...s.flexBetween, flexWrap: 'wrap', gap: '8px', marginBottom: ipucu ? '4px' : '12px' }}>
        <div style={s.sectionTitle}>{baslik}</div>
        {sag}
      </div>
      {ipucu && <p style={{ fontSize: '11.5px', color: colors.textSecondary, margin: '0 0 14px' }}>{ipucu}</p>}
      {children}
    </div>
  )
}

function UrunSatiri({ seo, bilgi, ilk, son, yukari, asagi, sil }) {
  const yok = !bilgi
  const stoksuz = bilgi && Number(bilgi.stock) <= 0
  return (
    <div style={{
      display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px 10px', padding: '7px 10px',
      border: '1px solid ' + colors.border,
      background: yok || stoksuz ? colors.bgPage : colors.bgCard,
      borderRadius: radius.sm, marginBottom: '6px'
    }}>
      {bilgi && bilgi.image_url
        ? <img src={bilgi.image_url} alt="" style={{ width: '30px', height: '42px', objectFit: 'contain', flexShrink: 0 }} />
        : <div style={{ width: '30px', height: '42px', background: colors.bgHover, borderRadius: radius.sm, flexShrink: 0 }} />}
      <div style={{ flex: '1 1 160px', minWidth: 0 }}>
        <div style={{ fontSize: '12.5px', fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {bilgi ? bilgi.name : seo}
        </div>
        <div className="sx-break" style={{ fontSize: '11px', color: colors.textMuted, fontFamily: 'monospace' }}>{seo}</div>
      </div>
      {yok && <span style={ui.chip}>katalogda yok</span>}
      {!yok && stoksuz && <span style={ui.chip}>stok yok</span>}
      <button style={{ ...ui.btnQuiet, padding: '3px 8px' }} onClick={yukari} disabled={ilk}>↑</button>
      <button style={{ ...ui.btnQuiet, padding: '3px 8px' }} onClick={asagi} disabled={son}>↓</button>
      <button style={{ ...ui.btnDangerQuiet, padding: '3px 8px' }} onClick={sil}>Sil</button>
    </div>
  )
}

function UrunEkle({ brandId, publisher, onSec }) {
  const [ac, setAc] = useState(false)
  const [q, setQ] = useState('')
  const [sonuc, setSonuc] = useState([])
  const [ara, setAra] = useState(false)

  function bul() {
    if (!q.trim()) return
    setAra(true)
    const token = localStorage.getItem('adminToken')
    axios.get(`${API}/admin/brands/${brandId}/smart-showcase/products`, {
      headers: { Authorization: token }, params: { q, publisher }
    }).then(r => setSonuc(r.data.products || [])).catch(() => { }).finally(() => setAra(false))
  }

  if (!ac) return <button style={{ ...s.btnSecondary, marginTop: '4px' }} onClick={() => setAc(true)}>Ürün ekle</button>

  return (
    <div style={{ ...s.cardFlat, marginTop: '8px', padding: '12px' }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: sonuc.length ? '10px' : 0 }}>
        <input style={{ ...s.inputSm, flex: '1 1 180px', minWidth: 0 }} autoFocus placeholder="Ürün adı veya kodu ara"
          value={q} onChange={e => setQ(e.target.value)} onKeyDown={e => e.key === 'Enter' && bul()} />
        <button style={ui.btnSm} onClick={bul} disabled={ara}>{ara ? 'Aranıyor…' : 'Ara'}</button>
        <button style={ui.btnQuiet} onClick={() => { setAc(false); setQ(''); setSonuc([]) }}>Kapat</button>
      </div>
      {sonuc.map(p => (
        <div key={p.external_id} style={{
          display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px 10px', padding: '6px 8px',
          borderBottom: '1px solid ' + colors.borderLight, cursor: 'pointer'
        }} onClick={() => { onSec(p); setQ(''); setSonuc([]) }}>
          {p.image_url && <img src={p.image_url} alt="" style={{ width: '26px', height: '36px', objectFit: 'contain', flexShrink: 0 }} />}
          <div style={{ flex: '1 1 160px', minWidth: 0 }}>
            <div className="sx-break" style={{ fontSize: '12.5px', fontWeight: 600 }}>{p.name}</div>
            <div className="sx-break" style={{ fontSize: '11px', color: colors.textMuted, fontFamily: 'monospace' }}>{p.product_code}</div>
          </div>
          {Number(p.stock) <= 0 && <span style={ui.chip}>stok yok</span>}
          <button style={ui.btnQuiet}>Ekle →</button>
        </div>
      ))}
    </div>
  )
}

function YazarSatiri({ y, bilgi, ilk, son, yukari, asagi, sil, urunSec, urunKaldir, brandId, publisher }) {
  const [barkod, setBarkod] = useState('')
  const [ara, setAra] = useState(false)
  const [degistir, setDegistir] = useState(false)
  const [hata, setHata] = useState('')
  const urunVar = !!y.urun
  const stoksuz = bilgi && Number(bilgi.stock) <= 0

  function getir() {
    const b = barkod.replace(/\s+/g, '')
    if (!b) return
    setAra(true); setHata('')
    const token = localStorage.getItem('adminToken')
    axios.get(`${API}/admin/brands/${brandId}/smart-showcase/product-by-barcode`, {
      headers: { Authorization: token }, params: { barcode: b, publisher }
    }).then(r => {
      if (!r.data.product) { setHata(r.data.mesaj || 'Ürün bulunamadı'); return }
      urunSec(r.data.product); setBarkod(''); setDegistir(false)
    }).catch(e => setHata(e.response?.data?.error || e.message)).finally(() => setAra(false))
  }

  return (
    <div style={{ border: '1px solid ' + colors.border, background: y.foto ? colors.bgCard : colors.bgPage, borderRadius: radius.sm, marginBottom: '6px', padding: '8px 10px' }}>
      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px 10px' }}>
        {y.foto
          ? <img src={y.foto} alt="" style={{ width: '36px', height: '36px', borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
          : <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: colors.bgHover, flexShrink: 0 }} />}
        <div style={{ flex: '1 1 160px', minWidth: 0 }}>
          <div style={{ fontSize: '12.5px', fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {y.ad}{y.kitap ? <span style={{ fontWeight: 400, color: colors.textMuted }}> · {y.kitap} kitap</span> : null}
          </div>
          <div className="sx-break" style={{ fontSize: '11px', color: colors.textMuted, fontFamily: 'monospace' }}>{y.seoLink || 'yazar sayfası yok'}</div>
        </div>
        {!y.foto && <span style={ui.chip}>portre yok, basılmaz</span>}
        <button style={{ ...ui.btnQuiet, padding: '3px 8px' }} onClick={yukari} disabled={ilk}>↑</button>
        <button style={{ ...ui.btnQuiet, padding: '3px 8px' }} onClick={asagi} disabled={son}>↓</button>
        <button style={{ ...ui.btnDangerQuiet, padding: '3px 8px' }} onClick={sil}>Sil</button>
      </div>
      <div className="sx-wrap" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px 10px', marginTop: '8px', paddingLeft: '46px', maxWidth: '100%' }}>
        <span style={{ fontSize: '11.5px', color: colors.textSecondary, flexShrink: 0 }}>Öne çıkan kitap:</span>
        {urunVar && !degistir ? (
          <>
            {bilgi && bilgi.image_url
              ? <img src={bilgi.image_url} alt="" style={{ width: '22px', height: '31px', objectFit: 'contain', flexShrink: 0 }} />
              : null}
            <div style={{ flex: '1 1 140px', minWidth: 0, fontSize: '12px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {bilgi ? bilgi.name : y.urun}
              {y.barkod ? <span style={{ color: colors.textMuted, fontFamily: 'monospace' }}> · {y.barkod}</span> : null}
            </div>
            {!bilgi && <span style={ui.chip}>katalogda yok</span>}
            {bilgi && stoksuz && <span style={ui.chip}>stok yok</span>}
            {bilgi && bilgi.farkli_yayinevi && <span style={ui.chip}>başka yayınevi</span>}
            <button style={{ ...ui.btnQuiet, padding: '3px 8px' }} onClick={() => setDegistir(true)}>Barkodla değiştir</button>
            <button style={{ ...ui.btnDangerQuiet, padding: '3px 8px' }} onClick={urunKaldir}>Kaldır</button>
          </>
        ) : (
          <>
            <input style={{ ...s.inputSm, maxWidth: '200px', flex: '1 1 140px', minWidth: 0 }} placeholder="Barkod" value={barkod}
              onChange={e => setBarkod(e.target.value)} onKeyDown={e => e.key === 'Enter' && getir()} />
            <button style={ui.btnSm} onClick={getir} disabled={ara}>{ara ? 'Getiriliyor…' : 'Getir'}</button>
            {degistir && <button style={ui.btnQuiet} onClick={() => { setDegistir(false); setBarkod(''); setHata('') }}>Vazgeç</button>}
            {!urunVar && !degistir && <span style={{ ...ui.emptyText, fontSize: '11px' }}>Boş bırakılırsa yazarın en çok satan kitabı gösterilir.</span>}
            {hata && <span className="sx-break" style={{ ...ui.chip, color: colors.dangerText, whiteSpace: 'normal', maxWidth: '100%' }}>{hata}</span>}
          </>
        )}
      </div>
    </div>
  )
}

function YazarEkle({ brandId, publisher, mevcut, onSec }) {
  const [ac, setAc] = useState(false)
  const [q, setQ] = useState('')
  const [sonuc, setSonuc] = useState([])
  const [ara, setAra] = useState(false)
  const [arandi, setArandi] = useState(false)

  function getir() {
    if (q.trim().length < 2) return
    setAra(true)
    const token = localStorage.getItem('adminToken')
    axios.get(`${API}/admin/brands/${brandId}/smart-showcase/authors`, {
      headers: { Authorization: token }, params: { q: q.trim(), publisher }
    }).then(r => { setSonuc(r.data.authors || []); setArandi(true) }).catch(() => { }).finally(() => setAra(false))
  }

  if (!ac) return <button style={{ ...s.btnSecondary, marginTop: '4px' }} onClick={() => setAc(true)}>Yazar ekle</button>

  return (
    <div style={{ ...s.cardFlat, marginTop: '8px', padding: '12px' }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: sonuc.length ? '10px' : 0 }}>
        <input style={{ ...s.inputSm, flex: '1 1 180px', minWidth: 0 }} autoFocus placeholder="Yazar adı"
          value={q} onChange={e => setQ(e.target.value)} onKeyDown={e => e.key === 'Enter' && getir()} />
        <button style={ui.btnSm} onClick={getir} disabled={ara}>{ara ? 'Getiriliyor…' : 'Getir'}</button>
        <button style={ui.btnQuiet} onClick={() => { setAc(false); setQ(''); setSonuc([]); setArandi(false) }}>Kapat</button>
      </div>
      {arandi && !sonuc.length && <div style={{ ...ui.emptyText, fontSize: '12px', marginTop: '8px' }}>Bu adla yazar bulunamadı.</div>}
      {sonuc.map(y => {
        const ekli = (mevcut || []).some(m => (m.modelId && m.modelId === y.modelId) || m.ad === y.ad)
        return (
          <div key={y.modelId} style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px 10px', padding: '6px 8px', borderBottom: '1px solid ' + colors.borderLight, cursor: ekli ? 'default' : 'pointer', opacity: ekli ? 0.5 : 1 }}
            onClick={() => { if (ekli) return; onSec(y); setQ(''); setSonuc([]); setArandi(false) }}>
            {y.foto
              ? <img src={y.foto} alt="" style={{ width: '30px', height: '30px', borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
              : <div style={{ width: '30px', height: '30px', borderRadius: '50%', background: colors.bgHover, flexShrink: 0 }} />}
            <div style={{ flex: '1 1 160px', minWidth: 0 }}>
              <div className="sx-break" style={{ fontSize: '12.5px', fontWeight: 600 }}>{y.ad}</div>
              <div className="sx-break" style={{ fontSize: '11px', color: colors.textMuted, fontFamily: 'monospace' }}>{y.seoLink} · {y.kitap} kitap</div>
            </div>
            {!y.foto && <span style={ui.chip}>portre yok</span>}
            <button style={ui.btnQuiet} disabled={ekli}>{ekli ? 'Listede' : 'Ekle →'}</button>
          </div>
        )
      })}
    </div>
  )
}

export default function SmartShowcase() {
  const { selectedBrand } = useBrand()
  const [cfg, setCfg] = useState(null)
  const [tab, setTab] = useState('yayinevi')
  const [liste, setListe] = useState([])
  const [sel, setSel] = useState(null)
  const [meta, setMeta] = useState(null)
  const [data, setData] = useState(null)
  const [urun, setUrun] = useState({})
  const [stats, setStats] = useState(null)
  const [runs, setRuns] = useState([])
  const [calisiyor, setCalisiyor] = useState(false)
  const [msg, setMsg] = useState(null)
  const [busy, setBusy] = useState(false)
  const [yukleniyor, setYukleniyor] = useState(false)

  const token = localStorage.getItem('adminToken')
  const headers = { Authorization: token }
  const bid = selectedBrand ? selectedBrand.id : null

  function flash(text, ok = true) { setMsg({ text, ok }); setTimeout(() => setMsg(null), 5000) }

  useEffect(() => {
    if (!bid) return
    setCfg(null); setSel(null); setData(null); setListe([])
    axios.get(`${API}/admin/brands/${bid}/smart-showcase-config`, { headers })
      .then(r => setCfg(r.data)).catch(() => setCfg({ enabled: false }))
  }, [bid]) // eslint-disable-line

  useEffect(() => {
    if (!bid || !cfg || !cfg.enabled) return
    if (tab === 'yayinevi' && !liste.length) yayineviListesi()
    if (tab === 'yazar' && !stats) yazarVerisi()
  }, [bid, cfg, tab]) // eslint-disable-line

  function yayineviListesi() {
    setYukleniyor(true)
    axios.get(`${API}/admin/brands/${bid}/smart-showcase/publishers`, { headers })
      .then(r => setListe(r.data.publishers || []))
      .catch(e => flash(e.response?.data?.error || e.message, false))
      .finally(() => setYukleniyor(false))
  }

  function yazarVerisi() {
    axios.get(`${API}/admin/brands/${bid}/smart-showcase/model-stats`, { headers })
      .then(r => setStats(r.data)).catch(() => { })
    axios.get(`${API}/admin/brands/${bid}/smart-showcase/runs`, { headers })
      .then(r => setRuns(r.data.runs || [])).catch(() => { })
    calismaDurumu(true)
  }

  function calismaDurumu(sessiz) {
    return axios.get(`${API}/admin/brands/${bid}/smart-showcase/model-run-status`, { headers })
      .then(r => {
        setCalisiyor(!!r.data.calisiyor)
        return r.data
      })
      .catch(() => { if (!sessiz) setCalisiyor(false); return null })
  }

  function yazarlariGuncelle() {
    if (!window.confirm('Tüm yazar vitrinleri yeniden üretilip canlıya yazılacak. Yaklaşık 1-2 dakika sürer. Devam edilsin mi?')) return
    setBusy(true)
    axios.post(`${API}/admin/brands/${bid}/smart-showcase/model-run`, {}, { headers })
      .then(() => {
        setCalisiyor(true)
        flash('Güncelleme başladı. Tamamlanınca sonuç aşağıdaki tabloya düşecek.')
        const t = setInterval(() => {
          calismaDurumu(true).then(d => {
            if (d && !d.calisiyor) {
              clearInterval(t)
              yazarVerisi()
              const y = d.son ? d.son.yazilan : 0
              flash('Yazar vitrinleri güncellendi: ' + y + ' vitrin yazıldı.')
            }
          })
        }, 5000)
      })
      .catch(e => {
        if (e.response && e.response.status === 409) { setCalisiyor(true); flash('Güncelleme zaten çalışıyor.', false) }
        else flash(e.response?.data?.error || e.message, false)
      })
      .finally(() => setBusy(false))
  }

  function ac(p) {
    setYukleniyor(true); setSel(p.tsoft_brand_id); setData(null)
    axios.get(`${API}/admin/brands/${bid}/smart-showcase/publisher/${p.tsoft_brand_id}`, { headers })
      .then(r => {
        const d = r.data.data || {}
        setData({
          mod: d.mod || undefined,
          bio: d.bio || '', video: d.video || '', pinYazar: d.pinYazar || '',
          basliklar: d.basliklar || {}, kategoriler: d.kategoriler || [],
          editor: d.editor || [], setler: d.setler || [], yayinlar: d.yayinlar || [],
          yazarlar: Array.isArray(d.yazarlar) ? d.yazarlar : []
        })
        setMeta({ name: r.data.name, kaynak: r.data.kaynak, published_at: r.data.published_at, published_by: r.data.published_by })
        cozUrunler(d)
      })
      .catch(e => flash(e.response?.data?.error || e.message, false))
      .finally(() => setYukleniyor(false))
  }

  function cozUrunler(d) {
    const hepsi = []
      .concat(...(d.kategoriler || []).map(k => k.urunler || []))
      .concat(d.editor || [], d.setler || [], d.yayinlar || [])
      .concat((d.yazarlar || []).map(y => y.urun).filter(Boolean))
    if (!hepsi.length) return
    axios.post(`${API}/admin/brands/${bid}/smart-showcase/resolve`, { seo: hepsi }, { headers })
      .then(r => {
        const m = {}
        const taban = (r.data.taban || '').replace(/\/+$/, '')
        ;(r.data.products || []).forEach(p => {
          const seo = String(p.product_url || '').replace(taban + '/', '').replace(/\/+$/, '').toLowerCase()
          m[seo] = p
        })
        setUrun(m)
      }).catch(() => { })
  }

  function setD(k, v) { setData(d => ({ ...d, [k]: v })) }
  function setBaslik(k, v) { setData(d => ({ ...d, basliklar: { ...(d.basliklar || {}), [k]: v } })) }

  function listeDegis(key, yeni) { setD(key, yeni) }
  function tasi(dizi, i, yon) {
    const a = dizi.slice(); const j = i + yon
    if (j < 0 || j >= a.length) return a
    const t = a[i]; a[i] = a[j]; a[j] = t
    return a
  }
  function seoCikar(p) {
    const t = String(p.product_url || '')
    const m = t.match(/^https?:\/\/[^/]+\/(.+)$/)
    return (m ? m[1] : t).replace(/\/+$/, '').toLowerCase()
  }

  function kaydet(sonra) {
    setBusy(true)
    axios.put(`${API}/admin/brands/${bid}/smart-showcase/publisher/${sel}`, { data, name: meta?.name }, { headers })
      .then(() => { flash('Kaydedildi'); if (sonra) sonra() })
      .catch(e => flash(e.response?.data?.error || e.message, false))
      .finally(() => setBusy(false))
  }

  function onizle() {
    setBusy(true)
    axios.post(`${API}/admin/brands/${bid}/smart-showcase/publisher/${sel}/preview`, { data }, { headers })
      .then(r => {
        const rp = r.data.rapor || {}
        const d = (rp.dusen || []).length
        flash('Önizleme: ' + rp.kart + ' kitap · ' + rp.set + ' set · ' + rp.kitaplik + ' yayın · ' + rp.yazar + ' yazar · ' + r.data.bayt + ' bayt'
          + (d ? ' — ' + d + ' seçim stok/pasif nedeniyle basılmayacak' : ''))
      })
      .catch(e => flash(e.response?.data?.error || e.message, false))
      .finally(() => setBusy(false))
  }

  function yayinla() {
    if (!window.confirm('Bu yayınevinin üst vitrini canlıya yazılacak. Devam edilsin mi?')) return
    setBusy(true)
    axios.post(`${API}/admin/brands/${bid}/smart-showcase/publisher/${sel}/publish`, { data }, { headers })
      .then(r => {
        const d = (r.data.rapor?.dusen || []).length
        flash('Yayınlandı (' + r.data.bayt + ' bayt' + (r.data.dogrulandi ? ', doğrulandı' : '') + ')'
          + (d ? ' — ' + d + ' seçim stok/pasif nedeniyle basılmadı' : '') + '. Sitede birkaç dakika içinde görünür.')
        yayineviListesi()
      })
      .catch(e => flash(e.response?.data?.error || e.message, false))
      .finally(() => setBusy(false))
  }

  function geriAl() {
    if (!window.confirm('Son yayından önceki sürüme dönülecek. Devam edilsin mi?')) return
    setBusy(true)
    axios.post(`${API}/admin/brands/${bid}/smart-showcase/publisher/${sel}/revert`, {}, { headers })
      .then(r => { flash('Geri alındı (' + r.data.bayt + ' bayt)'); yayineviListesi() })
      .catch(e => flash(e.response?.data?.error || e.message, false))
      .finally(() => setBusy(false))
  }

  if (!selectedBrand) return <div style={ui.notice}>Önce bir marka seçin.</div>
  if (!cfg) return <div style={ui.notice}>Yükleniyor…</div>

  if (!cfg.enabled) {
    return (
      <div>
        <h1 style={s.pageTitle}>Smart Showcase</h1>
        <p style={s.pageSubtitle}>Yayınevi ve yazar üst vitrinlerini panelden yönetin</p>
        <div style={{ ...ui.notice, marginTop: '18px' }}>
          <strong>Bu marka için üst vitrin tasarımı tanımlı değil.</strong>
          <div style={{ marginTop: '6px' }}>
            Smart Showcase, her markanın kendi vitrin tasarımına göre çalışır. {selectedBrand.name} için bir tasarım
            tanımlanmadığından modül kapalıdır. Etkinleştirmek için sistem yöneticinizle iletişime geçin.
          </div>
        </div>
      </div>
    )
  }

  return (
    <div>
      <div className="sx-wrap" style={{ ...s.flexBetween, flexWrap: 'wrap', gap: '10px', marginBottom: '18px' }}>
        <div>
          <h1 style={s.pageTitle}>Smart Showcase</h1>
          <p style={s.pageSubtitle}>Yayınevi ve yazar üst vitrinlerini panelden yönetin — {selectedBrand.name}</p>
        </div>
      </div>

      {msg && <div style={{ ...(msg.ok ? s.alertSuccess : s.alertDanger), marginBottom: '16px' }}>{msg.text}</div>}

      <div style={ui.tabBar}>
        {[{ key: 'yayinevi', label: 'Yayınevi Vitrini' }, { key: 'yazar', label: 'Yazar Vitrini' }].map(t => (
          <button key={t.key} onClick={() => { setTab(t.key); setSel(null) }} style={ui.tab(tab === t.key)}>{t.label}</button>
        ))}
      </div>

      {tab === 'yayinevi' && !sel && (
        <div style={s.card}>
          <div className="sx-wrap" style={{ ...s.flexBetween, flexWrap: 'wrap', gap: '10px', marginBottom: '12px' }}>
            <div>
              <div style={s.sectionTitle}>Yayınevleri</div>
              <p style={{ fontSize: '11.5px', color: colors.textSecondary, margin: '4px 0 0' }}>
                Panelden yayınlananlar üstte listelenir
              </p>
            </div>
            <button style={s.btnSecondary} onClick={yayineviListesi} disabled={yukleniyor}>
              {yukleniyor ? 'Yükleniyor…' : 'Yenile'}
            </button>
          </div>
          <div className="sx-scroll-x" style={{ overflowX: 'auto' }}>
            <table style={s.table}>
              <thead><tr>
                <th style={s.th}>Yayınevi</th>
                <th style={{ ...s.th, textAlign: 'right' }}>Ürün</th>
                <th style={s.th}>Durum</th>
                <th style={s.th}>Son yayın</th>
                <th style={s.th}></th>
              </tr></thead>
              <tbody>
                {liste.map(p => (
                  <tr key={p.tsoft_brand_id}>
                    <td style={s.td}>{p.name}</td>
                    <td style={{ ...s.td, ...ui.numMuted, textAlign: 'right' }}>{p.urun}</td>
                    <td style={s.td}>
                      {p.published_at ? <span style={ui.chipStrong}>panelden yayınlandı</span>
                        : p.panelde ? <span style={ui.chip}>taslak</span>
                          : p.tasarim_var ? <span style={ui.chip}>canlı tasarım var</span>
                            : <span style={ui.chip}>tasarım yok</span>}
                    </td>
                    <td style={{ ...s.td, fontSize: '12px', color: colors.textMuted }}>
                      {p.published_at ? new Date(p.published_at).toLocaleString('tr-TR') : '—'}
                    </td>
                    <td style={{ ...s.td, textAlign: 'right' }}>
                      <button style={ui.btnSm} onClick={() => ac(p)}>Düzenle</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {tab === 'yayinevi' && sel && (
        <div>
          <div className="sx-wrap" style={{ ...s.flexBetween, flexWrap: 'wrap', gap: '12px', marginBottom: '14px' }}>
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '10px', minWidth: 0 }}>
              <button style={ui.btnQuiet} onClick={() => { setSel(null); setData(null) }}>← Liste</button>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: '15px', fontWeight: 600 }}>{meta?.name}</div>
                <div className="sx-break" style={{ fontSize: '11.5px', color: colors.textMuted }}>
                  {meta?.published_at
                    ? 'Son yayın: ' + new Date(meta.published_at).toLocaleString('tr-TR') + (meta.published_by ? ' · ' + meta.published_by : '')
                    : meta?.kaynak === 'yeni'
                      ? 'Bu yayınevinin vitrini yok — varsayılan tasarımla boş başlıyor'
                      : 'Henüz panelden yayınlanmadı — içerik canlı vitrinden okundu'}
                </div>
              </div>
            </div>
            <div className="sx-wrap" style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              <button style={s.btnSecondary} onClick={onizle} disabled={busy || !data}>Önizle</button>
              <button style={s.btnSecondary} onClick={() => kaydet()} disabled={busy || !data}>Kaydet</button>
              <button style={s.btnPrimary} onClick={() => kaydet(yayinla)} disabled={busy || !data}>
                {busy ? 'Çalışıyor…' : 'Kaydet ve Yayınla'}
              </button>
              {meta?.published_at && <button style={ui.btnDangerQuiet} onClick={geriAl} disabled={busy}>Geri Al</button>}
            </div>
          </div>

          {!data && <div style={ui.notice}>Yükleniyor…</div>}

          {data && data.mod === 'manuel' && (
            <div style={{ ...ui.notice, marginBottom: '14px' }}>
              Bu vitrin panelden oluşturuluyor. Yalnızca içini doldurduğunuz bölümler yayınlanır; boş bırakılan bölümler vitrinde hiç görünmez.
            </div>
          )}

          {data && (
            <div>
              <Kutu baslik="Tanıtım" ipucu="Vitrinin en üstündeki yayınevi tanıtımı ve tanıtım videosu">
                <div style={{ marginBottom: '14px' }}>
                  <label style={s.labelNormal}>Yayınevi tanıtım metni</label>
                  <textarea style={{ ...s.input, minHeight: '92px', resize: 'vertical', fontFamily: 'inherit', lineHeight: 1.5 }}
                    value={data.bio} onChange={e => setD('bio', e.target.value)} />
                </div>
                <div>
                  <label style={s.labelNormal}>YouTube video kimliği</label>
                  <input style={{ ...s.input, maxWidth: '280px' }} value={data.video}
                    onChange={e => setD('video', e.target.value.trim())} placeholder="wlIydvODFQc" />
                  <p style={{ fontSize: '11.5px', color: colors.textSecondary, margin: '4px 0 0' }}>
                    Video adresindeki kimlik. Boş bırakılırsa video bölümü basılmaz.
                  </p>
                </div>
              </Kutu>

              <Kutu baslik={(data.basliklar?.kategoriler || 'Öne Çıkan Kategoriler')}
                ipucu="Sekme adı ve altında gösterilecek ürünler. İlk sekme vitrin açıldığında görünür.">
                <div style={{ marginBottom: '12px' }}>
                  <label style={s.labelNormal}>Bölüm başlığı</label>
                  <input style={{ ...s.input, maxWidth: '340px' }} value={data.basliklar?.kategoriler || ''}
                    placeholder="Öne Çıkan Kategoriler" onChange={e => setBaslik('kategoriler', e.target.value)} />
                </div>
                {(data.kategoriler || []).map((k, ki) => (
                  <div key={ki} style={{ ...s.cardFlat, marginBottom: '10px' }}>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap', marginBottom: '8px' }}>
                      <input style={{ ...s.inputSm, maxWidth: '260px', flex: '1 1 180px', minWidth: 0, fontWeight: 600 }} value={k.ad}
                        onChange={e => {
                          const a = data.kategoriler.slice(); a[ki] = { ...a[ki], ad: e.target.value }; setD('kategoriler', a)
                        }} />
                      <span style={{ ...ui.numMuted, fontSize: '11.5px' }}>{(k.urunler || []).length} ürün</span>
                      <div style={{ marginLeft: 'auto', display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                        <button style={{ ...ui.btnQuiet, padding: '3px 8px' }} disabled={ki === 0}
                          onClick={() => setD('kategoriler', tasi(data.kategoriler, ki, -1))}>↑</button>
                        <button style={{ ...ui.btnQuiet, padding: '3px 8px' }} disabled={ki === data.kategoriler.length - 1}
                          onClick={() => setD('kategoriler', tasi(data.kategoriler, ki, 1))}>↓</button>
                        <button style={{ ...ui.btnDangerQuiet, padding: '3px 8px' }}
                          onClick={() => setD('kategoriler', data.kategoriler.filter((_, j) => j !== ki))}>Sekmeyi sil</button>
                      </div>
                    </div>
                    {(k.urunler || []).map((seo, i) => (
                      <UrunSatiri key={seo + i} seo={seo} bilgi={urun[seo]}
                        ilk={i === 0} son={i === k.urunler.length - 1}
                        yukari={() => { const a = data.kategoriler.slice(); a[ki] = { ...a[ki], urunler: tasi(k.urunler, i, -1) }; setD('kategoriler', a) }}
                        asagi={() => { const a = data.kategoriler.slice(); a[ki] = { ...a[ki], urunler: tasi(k.urunler, i, 1) }; setD('kategoriler', a) }}
                        sil={() => { const a = data.kategoriler.slice(); a[ki] = { ...a[ki], urunler: k.urunler.filter((_, j) => j !== i) }; setD('kategoriler', a) }} />
                    ))}
                    <UrunEkle brandId={bid} publisher={sel} onSec={p => {
                      const seo = seoCikar(p)
                      const a = data.kategoriler.slice()
                      if ((a[ki].urunler || []).indexOf(seo) < 0) a[ki] = { ...a[ki], urunler: (a[ki].urunler || []).concat(seo) }
                      setD('kategoriler', a); setUrun(u => ({ ...u, [seo]: p }))
                    }} />
                  </div>
                ))}
                <button style={s.btnSecondary}
                  onClick={() => setD('kategoriler', (data.kategoriler || []).concat({ ad: 'Yeni Sekme', urunler: [] }))}>
                  Sekme ekle
                </button>
              </Kutu>

              {LISTE_BOLUMLERI.map(b => (
                <Kutu key={b.key} baslik={(data.basliklar?.[b.key] || b.varsayilan)} ipucu={b.ipucu}>
                  <div style={{ marginBottom: '12px' }}>
                    <label style={s.labelNormal}>Bölüm başlığı</label>
                    <input style={{ ...s.input, maxWidth: '340px' }} value={data.basliklar?.[b.key] || ''}
                      placeholder={b.varsayilan} onChange={e => setBaslik(b.key, e.target.value)} />
                  </div>
                  {(data[b.key] || []).map((seo, i) => (
                    <UrunSatiri key={seo + i} seo={seo} bilgi={urun[seo]}
                      ilk={i === 0} son={i === data[b.key].length - 1}
                      yukari={() => listeDegis(b.key, tasi(data[b.key], i, -1))}
                      asagi={() => listeDegis(b.key, tasi(data[b.key], i, 1))}
                      sil={() => listeDegis(b.key, data[b.key].filter((_, j) => j !== i))} />
                  ))}
                  <UrunEkle brandId={bid} publisher={sel} onSec={p => {
                    const seo = seoCikar(p)
                    if ((data[b.key] || []).indexOf(seo) < 0) listeDegis(b.key, (data[b.key] || []).concat(seo))
                    setUrun(u => ({ ...u, [seo]: p }))
                  }} />
                </Kutu>
              ))}

              <Kutu baslik={(data.basliklar?.yazarlar || 'Popüler Yazarlar')}
                ipucu="Yazar adını yazıp Getir ile T-Soft'taki yazar sayfasını bulun; öne çıkan kitabı barkodla getirin. Sıra ↑↓ ile değişir. Portresi olmayan yazar vitrinde basılmaz.">
                <div style={{ marginBottom: '12px' }}>
                  <label style={s.labelNormal}>Bölüm başlığı</label>
                  <input style={{ ...s.input, maxWidth: '340px' }} value={data.basliklar?.yazarlar || ''}
                    placeholder="Popüler Yazarlar" onChange={e => setBaslik('yazarlar', e.target.value)} />
                </div>
                {(data.yazarlar || []).map((y, i) => (
                  <YazarSatiri key={(y.modelId || y.ad) + i} y={y} bilgi={urun[y.urun]} brandId={bid} publisher={sel}
                    ilk={i === 0} son={i === data.yazarlar.length - 1}
                    yukari={() => setD('yazarlar', tasi(data.yazarlar, i, -1))}
                    asagi={() => setD('yazarlar', tasi(data.yazarlar, i, 1))}
                    sil={() => setD('yazarlar', data.yazarlar.filter((_, j) => j !== i))}
                    urunSec={p => {
                      const a = data.yazarlar.slice(); a[i] = { ...a[i], urun: p.seo, barkod: p.barkod }; setD('yazarlar', a)
                      setUrun(u => ({ ...u, [p.seo]: p }))
                    }}
                    urunKaldir={() => { const a = data.yazarlar.slice(); a[i] = { ...a[i], urun: '', barkod: '' }; setD('yazarlar', a) }} />
                ))}
                <YazarEkle brandId={bid} publisher={sel} mevcut={data.yazarlar || []} onSec={y => {
                  setD('yazarlar', (data.yazarlar || []).concat({ ad: y.ad, modelId: y.modelId, seoLink: y.seoLink, foto: y.foto, kitap: y.kitap, urun: '', barkod: '' }))
                }} />
                {!(data.yazarlar || []).length && (
                  <div style={{ marginTop: '14px' }}>
                    <p style={{ fontSize: '11.5px', color: colors.textSecondary, margin: '0 0 8px' }}>
                      Liste boşken yazarlar satış verisine göre otomatik seçilir. Buraya yazılan yazar ilk sıraya alınır.
                    </p>
                    <label style={s.labelNormal}>İlk sıraya sabitlenecek yazar</label>
                    <input style={{ ...s.input, maxWidth: '340px' }} value={data.pinYazar}
                      onChange={e => setD('pinYazar', e.target.value)} placeholder="Örn. Talha Uğurluel" />
                  </div>
                )}
              </Kutu>
            </div>
          )}
        </div>
      )}

      {tab === 'yazar' && (
        <div>
          <Kutu baslik="Tasarım kuralları"
            ipucu="Yazar üst vitrinleri bu kurallara göre her gece otomatik üretilir. Biyografi ve yazar görseli T-Soft panelinden girilir.">
            {MODEL_KURALLARI.map((k, i) => (
              <div key={i} style={{ display: 'flex', gap: '4px 12px', flexWrap: 'wrap', padding: '9px 0', borderBottom: i < MODEL_KURALLARI.length - 1 ? '1px solid ' + colors.borderLight : 'none' }}>
                <div style={{ width: '190px', maxWidth: '100%', fontSize: '13px', fontWeight: 600, flex: '0 1 190px', minWidth: 0 }}>{k.ad}</div>
                <div style={{ flex: '1 1 220px', minWidth: 0, fontSize: '12.5px', color: colors.textSecondary }}>{k.aciklama}</div>
              </div>
            ))}
          </Kutu>

          <Kutu baslik="Yazar vitrinlerini şimdi güncelle"
            ipucu="Vitrinler her gece 05:30'da otomatik güncellenir. Gün içinde yeni yazar veya kitap eklediyseniz, ertesi günü beklemeden buradan hemen güncelleyebilirsiniz.">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
              <button style={calisiyor ? s.btnSecondary : s.btnPrimary} onClick={yazarlariGuncelle} disabled={busy || calisiyor}>
                {calisiyor ? 'Güncelleme sürüyor…' : 'Tüm yazar vitrinlerini güncelle'}
              </button>
              <span style={{ fontSize: '12px', color: colors.textMuted }}>
                {calisiyor ? 'Tamamlanınca sonuç aşağıya düşecek.' : 'Yaklaşık 1-2 dakika sürer.'}
              </span>
            </div>
          </Kutu>

          <Kutu baslik="Yazar vitrini durumu" sag={
            <button style={s.btnSecondary} onClick={yazarVerisi}>Yenile</button>
          }>
            {!stats && <div style={ui.emptyText}>Yükleniyor…</div>}
            {stats && (
              <div className="sx-grid-stat" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>
                {[
                  { l: 'Toplam yazar', v: stats.toplam },
                  { l: 'Vitrini olan', v: stats.toplam - stats.bos },
                  { l: 'Güncel tasarım', v: stats.guncel_v2 },
                  { l: 'Güncellenmemiş', v: stats.eski_sablon + stats.yabanci }
                ].map((m, i) => (
                  <div key={i} style={ui.statBox}>
                    <div style={ui.statValue}>{Number(m.v).toLocaleString('tr-TR')}</div>
                    <div style={ui.statLabel}>{m.l}</div>
                  </div>
                ))}
              </div>
            )}
          </Kutu>

          <Kutu baslik="Günlük bakım geçmişi"
            ipucu="Her gece yayınevi ve yazar vitrinleri yeniden üretilir; kapaklar tazelenir, katalogdan çıkan ürünler vitrinden düşer.">
            {!runs.length && <div style={ui.emptyText}>Henüz kayıt yok.</div>}
            {runs.length > 0 && (
              <div className="sx-scroll-x" style={{ overflowX: 'auto' }}>
                <table style={s.table}>
                  <thead><tr>
                    <th style={s.th}>Tarih</th>
                    <th style={s.th}>Kapsam</th>
                    <th style={{ ...s.th, textAlign: 'right' }}>Güncellenen</th>
                    <th style={{ ...s.th, textAlign: 'right' }}>Değişmeyen</th>
                    <th style={{ ...s.th, textAlign: 'right' }}>Kapak</th>
                    <th style={{ ...s.th, textAlign: 'right' }}>Düşen kart</th>
                    <th style={{ ...s.th, textAlign: 'right' }}>Hata</th>
                  </tr></thead>
                  <tbody>
                    {runs.map(r => (
                      <tr key={r.id}>
                        <td style={{ ...s.td, fontSize: '12px' }}>{new Date(r.run_at).toLocaleString('tr-TR')}</td>
                        <td style={s.td}>{r.kapsam === 'marka' ? 'Yayınevi' : 'Yazar'}{r.durum === 'dry' ? ' (deneme)' : ''}</td>
                        <td style={{ ...s.td, ...ui.num, textAlign: 'right' }}>{r.yazilan}</td>
                        <td style={{ ...s.td, ...ui.numMuted, textAlign: 'right' }}>{r.degismeyen}</td>
                        <td style={{ ...s.td, ...ui.numMuted, textAlign: 'right' }}>{r.kapak_onarilan}</td>
                        <td style={{ ...s.td, ...ui.numMuted, textAlign: 'right' }}>{r.olu_kart_silinen}</td>
                        <td style={{ ...s.td, ...ui.numMuted, textAlign: 'right' }}>{r.hata}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </Kutu>
        </div>
      )}
    </div>
  )
}
